/**
 * Quantity Gifts - Add Button Handler
 * Integrates with existing quantity-gifts system
 * Adds main product + gift to cart together
 * DISABLES auto-add on main ATC button
 */

(function() {
  'use strict';
  
  
  const addedGifts = new Set();
  let mainProductAdded = false; // Track if main product has been added
  
  // DISABLE automatic gift adding when main ATC is clicked
  disableAutoGiftAdd();
  
  /**
   * Disable automatic gift adding on main Add to Cart button
   */
  function disableAutoGiftAdd() {
    
    // Override QuantityGifts updateGifts method to prevent auto-add
    const originalDefine = customElements.define;
    
    // Wait for QuantityGifts to be defined, then override its formVariants
    const checkForQuantityGifts = setInterval(() => {
      const quantityGiftsElement = document.querySelector('quantity-gifts');
      
      if (quantityGiftsElement) {
        clearInterval(checkForQuantityGifts);
        
        // Clear the unlockedItems array to prevent auto-add
        if (quantityGiftsElement.unlockedItems) {
          quantityGiftsElement.unlockedItems = [];
        }
        
        // Override the updateGifts method to clear formVariants
        const originalUpdateGifts = quantityGiftsElement.updateGifts;
        if (originalUpdateGifts) {
          quantityGiftsElement.updateGifts = function(quantity) {
            // Call original to unlock visually
            originalUpdateGifts.call(this, quantity);
            // But clear unlockedItems to prevent auto-add
            this.unlockedItems = [];
            this.formVariants = [];
          };
        }
        
        // Also intercept product-form submit to remove gift items
        interceptProductFormSubmit();
      }
    }, 100);
  }
  
  /**
   * Intercept product form submit to ALWAYS remove gift variants
   */
  function interceptProductFormSubmit() {
    const productForm = document.querySelector('product-form');
    if (!productForm) {
      return;
    }
    
    const form = productForm.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) {
      return;
    }
    
    // Listen to form submit before it's sent
    form.addEventListener('submit', function(e) {
      // Mark main product as added when main ATC is clicked
      mainProductAdded = true;
      
      // ALWAYS clear quantity-gifts unlockedItems before submit
      const quantityGifts = document.querySelector('quantity-gifts');
      if (quantityGifts) {
        // Force clear unlockedItems
        quantityGifts.unlockedItems = [];
        quantityGifts.formVariants = [];
      }
      
      // Add cart drawer opening after form submit
      setTimeout(async () => {
        await updateCartDrawer();
      }, 500); // Wait for form submission to complete
      
      // Find the hidden variants input container
      const variantsInput = form.querySelector('.product-form__variants');
      if (variantsInput) {
        // Get all gift variant IDs from the page
        const allGiftElements = document.querySelectorAll('.quantity-gift[data-product]');
        const giftVariantIds = Array.from(allGiftElements).map(el => el.dataset.product);
        
        
        if (giftVariantIds.length > 0 && variantsInput.innerHTML.trim() !== '') {
          
          // Parse the hidden inputs
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = variantsInput.innerHTML;
          
          // Remove ALL inputs that match gift variant IDs
          const inputs = tempDiv.querySelectorAll('input');
          let removedCount = 0;
          
          inputs.forEach(input => {
            const inputName = input.getAttribute('name') || '';
            const inputValue = input.value;
            
            // Check if this input is for a gift variant
            if (giftVariantIds.includes(inputValue)) {
              // Get the item index from name (e.g., items[1][id])
              const match = inputName.match(/items\[(\d+)\]/);
              if (match) {
                const itemIndex = match[1];
                // Remove ALL inputs for this item (id, quantity, properties)
                const itemInputs = tempDiv.querySelectorAll(`input[name^="items[${itemIndex}]"]`);
                itemInputs.forEach(inp => {
                  inp.remove();
                  removedCount++;
                });
              }
            }
          });
          
          if (removedCount > 0) {
            // Update the variants input with cleaned HTML
            variantsInput.innerHTML = tempDiv.innerHTML;
          }
        }
      }
    }, true); // Use capture phase to run before other listeners
    
  }
  
  // Initialize page
  function init() {
    // Gift elementinin yüklenmesini bekle
    const checkExist = setInterval(function() {
      const quantityGiftsElement = document.querySelector('quantity-gifts');
      if (quantityGiftsElement) {
        clearInterval(checkExist);
        setupButtons();
        observeGiftUnlocks();
      }
    }, 100);
  }
  
  /**
   * Gift unlock olduğunda butonları göster
   */
  function observeGiftUnlocks() {
    const quantityGiftsElement = document.querySelector('quantity-gifts');
    if (!quantityGiftsElement) return;
    
    // MutationObserver ile gift'lerin data-unlocked değişimini izle
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-unlocked') {
          const giftElement = mutation.target;
          const isUnlocked = giftElement.dataset.unlocked === 'true';
          const button = giftElement.querySelector('.gift-add-button');
          
          if (button) {
            if (isUnlocked) {
              button.style.display = 'block';
              button.disabled = false;
            } else {
              button.style.display = 'none';
              button.disabled = true;
            }
          }
        }
      });
    });
    
    // Tüm gift elementlerini izle
    const gifts = quantityGiftsElement.querySelectorAll('.quantity-gift');
    gifts.forEach(gift => {
      observer.observe(gift, { attributes: true });
      
      // İlk durumu kontrol et
      const isUnlocked = gift.dataset.unlocked === 'true';
      const button = gift.querySelector('.gift-add-button');
      if (button) {
        button.style.display = isUnlocked ? 'block' : 'none';
      }
    });
  }
  
  /**
   * Setup click listeners for gift buttons
   */
  function setupButtons() {
    const buttons = document.querySelectorAll('.gift-add-button');
    
    buttons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const giftElement = this.closest('.quantity-gift');
        const giftVariantId = giftElement.dataset.product;
        
        addMainProductAndGift(giftVariantId, this, giftElement);
      });
    });
  }
  
  /**
   * Get current selected quantity
   */
  function getSelectedQuantity() {
    // Try radio buttons first (quantity breaks)
    const checkedRadio = document.querySelector('input[type="radio"][name="quantity"]:checked');
    if (checkedRadio) {
      return parseInt(checkedRadio.value) || 1;
    }
    
    // Try normal quantity input
    const quantityInput = document.querySelector('input[name="quantity"]:not([type="radio"])');
    if (quantityInput) {
      return parseInt(quantityInput.value) || 1;
    }
    
    return 1;
  }

  /**
   * Get current quantity in cart for a specific variant ID
   */
  async function getCartQuantityForVariant(variantId) {
    try {
      const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      if (!res.ok) return 0;
      const cart = await res.json();
      if (!cart || !Array.isArray(cart.items)) return 0;
      let quantityInCart = 0;
      for (const item of cart.items) {
        if (String(item.id) === String(variantId)) {
          quantityInCart += Number(item.quantity) || 0;
        }
      }
      return quantityInCart;
    } catch (err) {
      // Silent error handling
      return 0;
    }
  }
  
  /**
   * Get main product variant ID
   */
  function getMainProductVariantId() {
    // Try hidden input in product form
    const variantInput = document.querySelector('input[name="id"].product-variant-id');
    if (variantInput) {
      return variantInput.value;
    }
    
    // Try form input
    const formInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (formInput) {
      return formInput.value;
    }
    
    return null;
  }
  
  /**
   * Add main product + gift to cart
   * Uses same logic as main Add to Cart button for proper cart drawer
   */
  async function addMainProductAndGift(giftVariantId, button, giftElement) {
    // Check if gift already added
    if (addedGifts.has(giftVariantId)) {
      showMessage('This gift is already in cart', 'info');
      return;
    }
    
    // Button loading state
    const originalText = button.innerHTML;
    button.disabled = true;
    button.innerHTML = 'Adding...';
    
    try {
      const mainVariantId = getMainProductVariantId();
      const requiredQuantity = getSelectedQuantity();
      
      if (!mainVariantId) {
        throw new Error('Main product variant not found');
      }
      
      
      // Prepare items to add
      const itemsToAdd = [];

      // Decide how much main product to add based on cart state
      let mainQtyToAdd = 0;
      const currentInCart = await getCartQuantityForVariant(mainVariantId);
      if (!mainProductAdded) {
        // If not previously added via gift flow, ensure cart reaches requiredQuantity
        if (currentInCart < requiredQuantity) {
          mainQtyToAdd = requiredQuantity - currentInCart;
        }
      } else {
        // Already added via gift flow once; only top-up if cart below required
        if (currentInCart < requiredQuantity) {
          mainQtyToAdd = requiredQuantity - currentInCart;
        }
      }

      if (mainQtyToAdd > 0) {
        itemsToAdd.push({ id: mainVariantId, quantity: mainQtyToAdd });
        mainProductAdded = true;
      } else {
      }
      
      // Always add the gift
      itemsToAdd.push({
        id: giftVariantId,
        quantity: 1,
        properties: { '_is_gift': 'true' }
      });
      
      
      // Add items to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: itemsToAdd
        })
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add to cart');
      }
      
      const cartData = await response.json();
      
      // Mark as added
      addedGifts.add(giftVariantId);
      button.innerHTML = '✓ Added';
      button.classList.add('added');
      
      // Check if discount code needs to be applied
      const discountCode = button.dataset.discountCode;
      if (discountCode && discountCode.trim() !== '') {
        // Apply discount code via cart update (non-blocking)
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                'discount_code': discountCode.trim()
              }
            })
          });
        } catch (err) {
          // Silent error - discount will still work at checkout
        }
      }
      
      // Show appropriate message
      if (mainQtyToAdd > 0) {
        showMessage('Main product adjusted and gift added to cart!', 'success');
      } else {
        showMessage('Gift added to cart!', 'success');
      }
      giftElement.classList.add('claimed');
      
      // Update and open cart drawer
      await updateCartDrawer();
      
      // DON'T trigger publish - it causes errors in shrine.null.js
      // The manual cart update above is sufficient
      
      showMessage('Added to cart!', 'success');
      
    } catch (error) {
      // Silent error handling
      button.disabled = false;
      button.innerHTML = originalText;
      showMessage(error.message || 'Error adding to cart', 'error');
    }
  }
  
  /**
   * Update cart drawer content and open it
   */
  async function updateCartDrawer() {
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      return;
    }
    
    try {
      // Fetch fresh cart data
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      
      // Update header cart icon with retry logic
      let cartIcon = document.querySelector('#cart-icon-bubble');
      let retries = 0;
      const maxRetries = 10;
      
      while (!cartIcon && retries < maxRetries) {
        await new Promise(resolve => setTimeout(resolve, 100));
        cartIcon = document.querySelector('#cart-icon-bubble');
        retries++;
      }
      
      
      if (cartIcon) {
        
        // Check if cart count bubble already exists
        let cartCountBubble = cartIcon.querySelector('.cart-count-bubble');
        
        if (cart.item_count > 0) {
          // Create cart count bubble if it doesn't exist (using original theme structure)
          if (!cartCountBubble) {
            cartCountBubble = document.createElement('div');
            cartCountBubble.className = 'cart-count-bubble';
            if (cart.item_count < 100) {
              cartCountBubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
            }
            cartCountBubble.innerHTML += `<span class="visually-hidden">${cart.item_count} items in cart</span>`;
            cartIcon.appendChild(cartCountBubble);
          } else {
            // Update existing bubble
            const cartCountSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
            if (cartCountSpan) {
              cartCountSpan.textContent = cart.item_count;
            }
          }
        } else {
          // Remove cart count bubble if it exists
          if (cartCountBubble) {
            cartCountBubble.remove();
          }
        }
      }
      
      // Also update any other cart count elements
      const allCartCounts = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
      allCartCounts.forEach(element => {
        element.textContent = cart.item_count;
        if (element.hasAttribute('data-cart-count')) {
          element.setAttribute('data-cart-count', cart.item_count);
        }
      });
      
      // Fetch updated cart drawer HTML from Shopify
      const drawerResponse = await fetch('/?section_id=cart-drawer');
      const drawerHTML = await drawerResponse.text();
      
      // Parse and extract cart drawer content
      const parser = new DOMParser();
      const doc = parser.parseFromString(drawerHTML, 'text/html');
      const newDrawerContent = doc.querySelector('.drawer__inner');
      
      if (newDrawerContent) {
        const currentDrawerInner = cartDrawer.querySelector('.drawer__inner');
        if (currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerContent.innerHTML;
        }
      }
      
      // CRITICAL FIX: Remove is-empty class and ensure proper state
      cartDrawer.classList.remove('is-empty');
      
      // Also update the drawer element's state
      const drawer = cartDrawer.querySelector('.drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');
      }
      
      
      // Open cart drawer after content is updated
      setTimeout(() => {
        
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // Manually open the drawer
          cartDrawer.classList.add('active');
          cartDrawer.classList.add('animate');
          document.body.classList.add('overflow-hidden');
          
          // Ensure drawer element is also active
          if (drawer) {
            drawer.classList.add('active');
          }
        }
      }, 150);
      
    } catch (error) {
      // Silent error handling
      
      // Fallback: Just try to open the drawer
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    }
  }
  
  /**
   * Show notification message
   */
  function showMessage(message, type = 'success') {
    const existing = document.querySelector('.gift-message');
    if (existing) existing.remove();
    
    const messageEl = document.createElement('div');
    messageEl.className = `gift-message gift-message--${type}`;
    messageEl.textContent = message;
    document.body.appendChild(messageEl);
    
    setTimeout(() => messageEl.classList.add('show'), 10);
    setTimeout(() => {
      messageEl.classList.remove('show');
      setTimeout(() => messageEl.remove(), 300);
    }, 3000);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();

